import React, { useEffect, useContext } from 'react'
import ScrollToTop from '../../../../Shared/ScrollToTop';
import { NavLink } from 'react-router-dom';
import ShipperSignupImg from './../../../../../assets/images/wemover/web-image/auth/shipper-register.png';
import DriverSignupImg from './../../../../../assets/images/wemover/web-image/auth/driver-register.png';
import { ProjectTypeContext } from '../../../../../ContextHandle';
export default function Signup({ setActivePage, sectionRefs, setDefaultWebActiveMenu }) {
     /* eslint-disable */
    var projectType = useContext(ProjectTypeContext);
    const projectName = projectType.projectName;
    projectType = projectType.projectType;
    useEffect(() => {
        setActivePage(1006);
        document.title = 'Business signup | ' + projectName + ' web';
        setDefaultWebActiveMenu('1');
    }, [projectName]);
 
    return (
        <div className='d-flex flex-column justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div className=" right-content-box-width">
                <nav  >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href={`/${projectType}`}><i className='fa fa-home'></i></a></li>
                        <li className="breadcrumb-item" aria-current="page">Authentication</li>
                        <li className="breadcrumb-item active" aria-current="page">Signup</li>
                    </ol>
                </nav>
                <div id="accounts" ref={sectionRefs['51']}>
                    <h4 className="font-weight-bold mt-5  ">Signup</h4>
                    <h5 className="font-weight-bold mt-5  ">Shipper register</h5>
                    <p >New shipper accounts can be created. shipper need to fillup his all information</p>
                    <div className='pt-3'>
                        <img src={ShipperSignupImg} className="w-100 rounded" alt="shipper-register.png"></img>
                    </div>
                    <h5 className="font-weight-bold mt-5  ">Driver register</h5>
                    <p >New driver accounts can be created. driver need to fillup his all information and his need to select driver type like - Company, Individual.</p>
                    <div className='pt-3'>
                        <img src={DriverSignupImg} className="w-100 rounded" alt="driver-register.png"></img>
                    </div>
                </div>

                <div className="d-flex justify-content-between border-top mt-5">
                    <div className="text-start mt-4">
                        <NavLink to={`/${projectType}/login`} className="text-decoration-none">
                            <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                            <h4 className='pagination-title'>Login</h4>
                        </NavLink>
                    </div>
                    <div className="text-end my-2">
                        <NavLink to={`/${projectType}/forgot-password`} className="text-decoration-none">
                            <a href="#login" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                            <h4 className='pagination-title'>Forgot Password</h4>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    )
}
